import { CONFIG } from '../config.js';
import { legMultiplier } from './projections.js';
import { MARKETS } from './registry.js';
/**
 * Grade one leg against a settled result (spec: Build-Your-Card §7). An ungradeable
 * leg (unknown id, the anchor, no resolvable multiplier, or a market with no data —
 * e.g. a half-time leg on a result with no HT goals, or a coverage-gated leg the
 * provider didn't deliver) is EXCLUDED with factor 1, never scored as wrong —
 * mirroring how a void fixture is excluded. The multiplier is resolved PER OUTCOME:
 * an asymmetric market grades the picked side by ITS own multiplier.
 */
export function gradeLeg(leg, result) {
    const m = MARKETS[leg.marketId];
    if (!m || m.anchor || !m.gradeable(result)) {
        return { gradeable: false, hit: false, factor: 1 };
    }
    const mult = legMultiplier(leg.marketId, leg.selection);
    if (!(mult > 1)) {
        return { gradeable: false, hit: false, factor: 1 };
    }
    const hit = m.isHit(leg.selection, result);
    const factor = hit ? mult : Math.pow(mult, -CONFIG.COMBO.WRONG_LEG_EXPONENT);
    return { gradeable: true, hit, factor };
}
//# sourceMappingURL=grading.js.map